import GalleryItem from "./GalleryItem";
export default GalleryItem;
